import { render, staticRenderFns } from "./CreateIfttt.vue?vue&type=template&id=07bd2a85&scoped=true"
import script from "./CreateIfttt.vue?vue&type=script&lang=js"
export * from "./CreateIfttt.vue?vue&type=script&lang=js"
import style0 from "./CreateIfttt.vue?vue&type=style&index=0&id=07bd2a85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bd2a85",
  null
  
)

export default component.exports